import { IAppointmentButtonSettings } from '@/types';

export const defaultButtonsSettings: Record<
  string,
  IAppointmentButtonSettings
> = {
  schedule: {
    isSolid: false,
    colors: {
      background: '#001535',
      text: '#ffffff',
      highlight1: '#144693',
      highlight2: '#3476D8',
    },
  },
  onDemand: {
    isSolid: false,
    colors: {
      background: '#001535',
      text: '#ffffff',
      highlight1: '#A92E00',
      highlight2: '#F47E52',
    },
  },
  iHaveAppointment: {
    isSolid: false,
    colors: {
      background: '#001535',
      text: '#ffffff',
      highlight1: '#005244',
      highlight2: '#00A88E',
    },
  },
};

export const weekdayStringToDayjsNumberMap = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

export const KIOSK_AVAILABILITY_RECHECK_INTERVAL = 10 * 1000; // 10 secs in ms

export const MULTILINE_INPUT_MAX_LENGTH = 13500;
